import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Toastr } from "@revvsales/components";

import { ReactSelect } from "../../../commonComponents";

import {
  patchOppoAccessService,
  deleteOppoAccessService,
} from "../../../actions/PipelineActions/pipelineServices";

import { GlobalUtils } from "../../../utils";

// Destructuring
const { handleApiErrMsg } = GlobalUtils;

const accessLevels = ["View", "Edit"];

class AccessListing extends Component {
  state = {};

  _findAccessName = ({ write }) => {
    if (write) {
      return "Edit";
    }
    return "View";
  };

  _changeAccess = (value, people) => {
    if (this._findAccessName(people.Scope) !== value) {
      const person = {
        user: { id: people.User.id },
        object_type: "OPP",
        object_id: this.props.oppo.id,
        sharing_method: "EXPLICIT",
        sharing_hash: people.ShareHash,
        shared_until: "2019-12-20T14:37:12.995319+05:30",
        share: false,
        read: true,
      };
      if (value === "View") {
        person.write = false;
      } else if (value === "Edit") {
        person.write = true;
      }

      patchOppoAccessService([person])
        .then(() => {
          this.props.fetchOppoAccess(this.props.oppo.id);
          Toastr.showToastr({
            type: "success",
            message: "Access changed successfully.",
            timeout: 2000,
          });
        })
        .catch(err => {
          Toastr.showToastr({
            type: "failure",
            message: handleApiErrMsg(err),
            timeout: 3000,
          });
        });
    }
  };

  _deleteOppoAccess = hash => {
    deleteOppoAccessService(hash)
      .then(() => {
        this.props.fetchOppoAccess(this.props.oppo.id);
        Toastr.showToastr({
          type: "success",
          message: "Access deleted successfully.",
          timeout: 2000,
        });
      })
      .catch(err => {
        Toastr.showToastr({
          type: "failure",
          message: handleApiErrMsg(err),
          timeout: 3000,
        });
      });
  };

  _showOppoOwner = () => {
    const { owner: { name: OppOwner } = {} } = this.props.oppo;
    return (
      <div className="oppo-sharing-owner-name">
        <span className="oppo-sharing-access-list-name">{OppOwner || "-"}</span>
        <span className="oppo-sharing-access-list-access">
          <span className="invitesection-oppowner-text">Owner</span>
        </span>
      </div>
    );
  };

  render() {
    return (
      <div className="oppo-share-access-listing">
        <div className="oppo-share-access-listing-title">
          USERS WHO HAVE ACCESS:
        </div>
        {this._showOppoOwner()}
        <div className="oppo-sharing-access-list-wrapper">
          {this.props.list.map(people => (
            <div className="oppo-sharing-access-list">
              <span className="oppo-sharing-access-list-name">
                {people.User.name}
              </span>
              <span className="oppo-sharing-access-list-access">
                <span>
                  <ReactSelect
                    onChange={value => this._changeAccess(value.value, people)}
                    options={accessLevels}
                    value={this._findAccessName(people.Scope)}
                    data-test="accesslisting-select"
                  />
                </span>
                <span className="btn-icon oppo-sharing-access-list-delete">
                  <span
                    className="btn-icon"
                    onClick={() => this._deleteOppoAccess(people.ShareHash)}
                    onKeyPress={() => this._deleteOppoAccess(people.ShareHash)}
                    role="button"
                    tabIndex="0">
                    <FontAwesomeIcon icon={["far", "trash-alt"]} />
                  </span>
                </span>
              </span>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default AccessListing;



// WEBPACK FOOTER //
// ./src/components/PipelineWrapper/OppoSharingPopup/AccessListing.js